// Angular
import { ModuleWithProviders } from '@angular/core';
import { Routes } from '@angular/router';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
var ɵ0 = { returnUrl: window.location.pathname };
// Auth
// import { AuthEffects, AuthGuard, authReducer, AuthService } from '../../../core/auth';
var routes = [
    {
        path: '',
        component: AuthComponent,
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full'
            },
            {
                path: 'login',
                component: LoginComponent,
                data: ɵ0
            },
            {
                path: 'new-password',
                component: RegisterComponent
            },
            {
                path: 'forgot-password',
                component: ForgotPasswordComponent,
            }
        ]
    }
];
var AuthModule = /** @class */ (function () {
    function AuthModule() {
    }
    AuthModule.forRoot = function () {
        return {
            ngModule: AuthModule,
            providers: [
            // AuthService,
            // AuthGuard
            ]
        };
    };
    return AuthModule;
}());
export { AuthModule };
export { ɵ0 };
